// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"23775d92","737":"b0117d6d","762":"2c88dd51","826":"73a8bfde","876":"eb682009","951":"b238c446"}[chunkId] + ".chunk.js";
};